import { useGetBillingStatusQuery } from './billing.api';
import { useNavigate } from 'react-router-dom';

/**
 * Global billing status banner shown at the top of the admin app.
 * Warns photographers about past_due or canceled billing.
 */
export const BillingBanner = () => {
  const { data: billing } = useGetBillingStatusQuery();
  const navigate = useNavigate();

  if (!billing) return null;

  const { billingStatus } = billing;

  if (billingStatus === 'past_due') {
    return (
      <div
        style={{
          padding: '0.75rem 1rem',
          backgroundColor: '#fef2f2',
          borderBottom: '1px solid #fecaca',
          color: '#991b1b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '0.875rem',
        }}
      >
        <span>
          <strong>Payment failed.</strong> Please update your payment method to
          avoid service interruption.
        </span>
        <button
          onClick={() => navigate('/settings/billing')}
          style={{
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '0.375rem',
            padding: '0.375rem 0.75rem',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        >
          Fix Billing
        </button>
      </div>
    );
  }

  if (billingStatus === 'canceled') {
    return (
      <div
        style={{
          padding: '0.75rem 1rem',
          backgroundColor: '#f3f4f6',
          borderBottom: '1px solid #d1d5db',
          color: '#374151',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '0.875rem',
        }}
      >
        <span>
          <strong>Subscription canceled.</strong> Some features are restricted.
          Resubscribe to restore full access.
        </span>
        <button
          onClick={() => navigate('/settings/billing')}
          style={{
            background: '#4b5563',
            color: 'white',
            border: 'none',
            borderRadius: '0.375rem',
            padding: '0.375rem 0.75rem',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        >
          Resubscribe
        </button>
      </div>
    );
  }

  return null;
};
